<template>
  <TabBar>
    <template #tabs>
      <Tabs
        :activeTab="currentTab"
        :tabs="$options.tabList"
        @selectedTab="handleSelectedTab"
      />
    </template>
  </TabBar>
</template>

<script>
import {
  TabBar,
  Tabs,
  Types,
} from '@jumpcloud/ui-components';

const { TabItem } = Types;

const tabList = [
  TabItem({
    key: 'tab1',
    label: 'Tab 1',
  }),
  TabItem({
    key: 'tab2',
    label: 'Tab 2',
  }),
];

export default {
  name: 'StickerTabs',

  components: {
    Tabs,
    TabBar,
  },

  tabList,

  data() {
    return {
      currentTab: tabList[1].key,
    };
  },

  methods: {
    handleSelectedTab(tab) {
      this.currentTab = tab;
    },
  },
};
</script>

<style>

</style>
